// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"Contact_inputForm__1wyMV","btnFilled":"Contact_btnFilled__JzP_W","btnEmpty":"Contact_btnEmpty__QxBVu","messageDisplay":"Contact_messageDisplay__2QYsT"};